import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#A5ABB3",
      d: "M40 10H8v28l18.585-18.587a2 2 0 0 1 2.828 0L40 30.02zM4 7.987A2 2 0 0 1 5.984 6h36.032C43.112 6 44 6.89 44 7.987v32.026A2 2 0 0 1 42.016 42H5.984A1.985 1.985 0 0 1 4 40.013zM16 22a4 4 0 1 1 0-8 4 4 0 0 1 0 8"
    }, null, -1)
  ]))]))
}
export default { render: render }